import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH, PUB_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'fcadmin-login',
        path: `${AUTH_PREFIX_PATH}/fcadmin-login`,
        component: React.lazy(() => import('views/auth-views/authentication/admin-login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/password_reset`,
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
    },
    {
        key: 'public-cert-lookup',
        path: `${PUB_PREFIX_PATH}/lookup`,
        component: React.lazy(() => import('views/public/cert-replay')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.home',
        path: `${APP_PREFIX_PATH}/dashboard/home`,
        component: React.lazy(() => import('views/app-views/dashboards/home')),
    },
    {
        key: 'dashboard.domains',
        path: `${APP_PREFIX_PATH}/dashboard/domains`,
        component: React.lazy(() => import('views/app-views/dashboards/domains')),
    },
    {
        key: 'dashboard.certify',
        path: `${APP_PREFIX_PATH}/dashboard/certify`,
        component: React.lazy(() => import('views/app-views/dashboards/certify')),
    },
    {
        key: 'dashboard.lookup',
        path: `${APP_PREFIX_PATH}/dashboard/lookup`,
        component: React.lazy(() => import('views/app-views/dashboards/lookup')),
    },
    {
        key: 'dashboard.search',
        path: `${APP_PREFIX_PATH}/dashboard/search`,
        component: React.lazy(() => import('views/app-views/dashboards/search')),
    },
    {
        key: 'profile.settings',
        path: `${APP_PREFIX_PATH}/profile/settings`,
        component: React.lazy(() => import('views/profile-views/settings')),
    },
    {
        key: 'profile.api',
        path: `${APP_PREFIX_PATH}/profile/api`,
        component: React.lazy(() => import('views/profile-views/api')),
    },
    {
        key: 'profile.billing',
        path: `${APP_PREFIX_PATH}/profile/billing`,
        component: React.lazy(() => import('views/profile-views/billing')),
    }
]